function bmInspirationDetailInit(root) {
  if (root.dataset.detailReady) return;
  root.dataset.detailReady = 'true';
  const dialog = root.querySelector('[data-detail-dialog]');
  const image = dialog.querySelector('[data-detail-large]');
  let trigger;
  root.querySelectorAll('[data-detail-zoom]').forEach(button => button.addEventListener('click', () => {
    trigger = button;
    image.src = button.dataset.image;
    image.alt = button.dataset.alt;
    dialog.querySelector('[data-detail-caption]').textContent = button.dataset.alt;
    dialog.showModal();
  }));
  dialog.querySelector('[data-detail-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { image.removeAttribute('src'); trigger?.focus(); });
}
document.querySelectorAll('[data-inspiration-detail]').forEach(bmInspirationDetailInit);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-inspiration-detail]').forEach(bmInspirationDetailInit));
